import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EntitiesContext } from "../../../App";
import { useUpdateAccount } from "../../../hooks/useAccount";
import { useCreateToken } from "../../../hooks/useAdminAuth";

export default function Login() {
  const { state } = useContext(EntitiesContext);
  const navigate = useNavigate();
  const auth = useCreateToken();
  const update = useUpdateAccount();

  const [isEditing, setIsEditing] = useState(false);
  const [displayStaffMap, setDisplayStaffMap] = useState({});

  const trashIcon = <FontAwesomeIcon icon={faTrashCan} />;

  // Separate admins and cashiers
  const admins = state.get("account").filter((a) => a.role === "admin");
  const cashiers = state.get("account").filter((a) => a.role === "staff");

  const login = (user) => {
    // Clear any existing impersonation session when signing in as cashier/admin
    window.localStorage.removeItem('originalAdminAuth');
    window.localStorage.removeItem('loginAsSession');

    auth
      .mutateAsync(user)
      .then((res) => {
        navigate(`/admin/auth/${res.data}`);
      })
      .catch((err) => console.log(err));
  };

  const handleDisplayCheckboxChange = (cashier) => {
    if (cashier.id != null) {
      update.mutate(cashier.set("display_staff", !cashier.display_staff));
    }
  };

  const handleSigninCheckboxChange = (cashier) => {
    if (cashier.id != null) {
      update.mutate(cashier.set("allow_signin", !cashier.allow_signin));
    }
  };

  const saveChanges = () => {
    // Reset the editing state and displayStaffMap
    setIsEditing(false);
    setDisplayStaffMap({});
  };

  // Inline style objects
  const sectionHeaderStyle = {
    fontSize: "1.1rem",
    fontWeight: "bold",
    marginTop: "16px",
    color: "#b0b0b0",
    paddingBottom: "4px",
    borderBottom: "1px solid #444",
  };

  return (
    <div>
      <br />
      <div style={{ textAlign: "right" }}>
        <button
          className="button is-primary"
          onClick={() => setIsEditing((prev) => !prev)}
        >
          {isEditing ? "Done Editing" : "Edit Displayed Staff"}
        </button>
      </div>

      <div style={sectionHeaderStyle}>Admin</div>
      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            {isEditing && (
              <>
                <th>Display Staff</th> <th>Allow Signin</th>
              </>
            )}{" "}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {admins
            .sortBy((a) => a.last_name)
            .filter((a) => isEditing || a.display_staff)
            .valueSeq()
            .map((a) => (
              <tr key={a.id}>
                <td>{a.first_name}</td>
                <td>{a.last_name}</td>
                <td>{a.email}</td>
                {isEditing && (
                  <>
                    <td>
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          checked={a.display_staff}
                          onChange={() => handleDisplayCheckboxChange(a)}
                        />
                      </label>
                    </td>
                    <td>
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          checked={a.allow_signin}
                          onChange={() => handleSigninCheckboxChange(a)}
                        />
                      </label>
                    </td>
                  </>
                )}
                <td>
                  <button className="button is-link" onClick={() => login(a)} disabled={auth.isLoading}>
                    Login as {a.first_name} {a.last_name.split("")[0]}.
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      <div style={sectionHeaderStyle}>Cashiers</div>
      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            {isEditing && (
              <>
                <th>Display Staff</th> <th>Allow Signin</th>
              </>
            )}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {cashiers
            .sortBy((c) => c.last_name)
            .filter((c) => isEditing || c.display_staff)
            .valueSeq()
            .map((c) => (
              <tr key={c.id}>
                <td>{c.first_name}</td>
                <td>{c.last_name}</td>
                <td>{c.email}</td>
                {isEditing && (
                  <>
                    <td>
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          checked={c.display_staff}
                          onChange={() => handleDisplayCheckboxChange(c)}
                        />
                      </label>
                    </td>
                    <td>
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          checked={c.allow_signin}
                          onChange={() => handleSigninCheckboxChange(c)}
                        />
                      </label>
                    </td>
                  </>
                )}
                <td>
                  <button className="button is-link" onClick={() => login(c)} disabled={auth.isLoading}>
                    Login as {c.first_name} {c.last_name.split("")[0]}.
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {isEditing && (
        <button className="button is-success" onClick={saveChanges}>
          Save Changes
        </button>
      )}
    </div>
  );
}
